import { sdk } from "@/config/medusa";
import { useUser } from "@/context/user"
import { InventoryItem } from "@/types/inventory";
import { handleErrorToast } from "@/utils/helpers";
import storage from "@/utils/storage";
import { useQuery } from "@tanstack/react-query";

const useQueryInventory = ()  => {
    const isAuthenticated = useUser((state) => state.isAuthenticated);
    const vid = storage.getItem("vid");
    
    const getInventory = async () => {
        try {
            const data = await sdk.client.fetch<InventoryItem[]>(`/vendor/${vid}/inventory`);
            return data;
        } catch (e) {
            handleErrorToast(e);
        }
    }
    const query = useQuery({
        queryKey: ["inventory", vid],
        queryFn: getInventory,
        enabled: isAuthenticated,
    });

    return {
        ...query,
        isFetching: query.isFetching,
    }
}
export default useQueryInventory;